<app-dashboard-header></app-dashboard-header>

<main>
  <div class="container">
    <h2 class="mt-5">الصلاحيــــات</h2>
    <table class="table table-bordered table-hover mt-5 mb-5">
      <thead class="thead-dark">
        <tr>
      
          <th>نوع الصلاحيــــة</th>
       
          <th>العمليــات</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let role of roles; let i = index" routerLink="/getRoleByID/{{ role._id }}" style="cursor: pointer;">
        
          <td>{{ role.type }}</td>
         
          <td>
            <a class="update btn btn-success" routerLink="/updateRole/{{ role._id }}">التعـــديل</a>            
            <a class="delete btn btn-secondary" (click)="delete(role._id)">الحـــذف</a>            
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</main>

<app-dashboard-footer></app-dashboard-footer>
